/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Nav_BreadcrumbsInputs */

const de_commons_nav_breadcrumbs = /** @type {(inputs: Commons_Nav_BreadcrumbsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navigationspfad`)
};

/** @type {(inputs: Commons_Nav_BreadcrumbsInputs) => LocalizedString} */
const en_commons_nav_breadcrumbs = de_commons_nav_breadcrumbs;

/**

* @param {Commons_Nav_BreadcrumbsInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_nav_breadcrumbs = /** @type {((inputs?: Commons_Nav_BreadcrumbsInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Nav_BreadcrumbsInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_nav_breadcrumbs(inputs)
	return en_commons_nav_breadcrumbs(inputs)
});